






























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import PicUpload from "@/components/picUpload/index.vue";
@Component({
  name: "onlineBooking",
  components: {
    PicUpload,
  },
})
export default class onlineBooking extends Vue {
  private zItem!: any;
  private answer: any = "";
  @Prop({ type: String, default: "EDIT" }) viewMode!: string;

  @Prop({ type: Object, default: {} })
  item!: any;

  @Prop({ type: Number, default: 0 }) zIndex!: number;
  @Prop({ type: Boolean, default: true }) Required!: boolean;
  @Watch("zIndex", { immediate: true })
  @Watch("item", { immediate: true, deep: true })
  dataChage(value: any) {
    this.zItem = value;
    if (this.viewMode == "ANSWERREVIEW") {
      if (value.answer) {
        this.answer = value.answer.map((item: any) => {
          const dateAndHourly = item.split("_");
          const reservation: any = { date: dateAndHourly[0] };
          if (dateAndHourly.length > 1) reservation.hourly = dateAndHourly[1] + " - " + dateAndHourly[2];
          return reservation;
        });
      }
    }
  }
  weekDays(day: any) {
    const date = new Date(day);
    const weekDays = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
    return weekDays[date.getDay()];
  }
}
